






















































































































































































































































































































































































































































































































































import Vue, {VueConstructor} from 'vue'
import User from '@/models/Users/User'
import {Dictionary} from 'vuex'
import {CONF_VK_COMMUNITY_LINK, CONF_TG_BOT_NAME, CONF_MAX_BOT_NAME, MSGR_VK, MSGR_MAX, MSGR_TG, MSGR_TT, MSGR_VB, CONF_VB_BOT_NAME, CONF_TT_BOT_NAME, CONF_MESSENGER_VK, CONF_MESSENGER_MAX, CONF_MESSENGER_TG, CONF_MESSENGER_VB, CONF_MESSENGER_TT, MSGR_DC, CONF_DC_BOT_NAME, CONF_MESSENGER_DISCORD, CONF_DC_APP_NAME, CONF_DC_APP_AUTHLINK, CONF_DC_APP_LINK} from '@/constants'
import config from '@/config'
import UiTimer from '@/components/Ui/Timer/Timer.vue'
import UiSwitch from '@/components/Ui/Switch/switch_v2.vue'
import _ from 'lodash'

// @ts-ignore
import messages from '@/lang/index';

const MSGR_DICT: {[key: string]: string} = {
  [MSGR_VK]: messages.common.socials.vk,
  [MSGR_TG]: messages.common.socials.tg,
  [MSGR_VB]: messages.common.socials.vb,
  [MSGR_TT]: messages.common.socials.tt,
  // [MSGR_MAX]: messages.common.socials.tt,
  [MSGR_MAX]: 'MAX',
  [MSGR_DC]: 'Discord'
}
interface ICodes {
  [key: string]: {
    code: string
    expire: number
    msgr: string
  }
}
export default (Vue as VueConstructor<Vue & {
  $copyText: (text: string) => void
}>).extend({
  components: {
    UiTimer,
    UiSwitch
  },
  data () {
    return {
      popupVisible: {
        [MSGR_MAX]: false,
        [MSGR_VK]: false,
        [MSGR_TG]: false,
        [MSGR_VB]: false,
        [MSGR_TT]: false,
        [MSGR_DC]: false
      } as {[key: string]: boolean},
      confirmVisible: {
        [MSGR_MAX]: false,
        [MSGR_VK]: false,
        [MSGR_TG]: false,
        [MSGR_VB]: false,
        [MSGR_TT]: false,
        [MSGR_DC]: false
      } as {[key: string]: boolean},
      VK_COMMUNITY_LINK: config(CONF_VK_COMMUNITY_LINK),
      MAX_BOT_NAME: config(CONF_MAX_BOT_NAME),
      TG_BOT_NAME: config(CONF_TG_BOT_NAME),
      VB_BOT_NAME: config(CONF_VB_BOT_NAME),
      TT_BOT_NAME: config(CONF_TT_BOT_NAME),
      DISCORD_BOT_NAME: config(CONF_DC_BOT_NAME),
      DC_APP_NAME: config(CONF_DC_APP_NAME),
      DC_APP_AUTHLINK: config(CONF_DC_APP_AUTHLINK),
      DC_APP_LINK: config(CONF_DC_APP_LINK),
      MSGR_MAX,
      MSGR_VK,
      MSGR_TG,
      MSGR_VB,
      MSGR_TT,
      MSGR_DC,
      interval: null,
      codes: {} as Dictionary<ICodes>
    }
  },
  computed: {
    msgr (): string[] | false {
      if (this.user) {
        return this.user.getMsgrs();
      } else {
        return false;
      }
    },
    user (): User | false {
      return this.$store.state.user.user;
    },
    serverTime (): number {
      return this.$store.state.serverTime;
    },
    isShowMax (): boolean {
      return this.isShowMessenger(CONF_MESSENGER_MAX);
    },
    isShowVK (): boolean {
      return this.isShowMessenger(CONF_MESSENGER_VK);
    },
    isShowTG (): boolean {
      return this.isShowMessenger(CONF_MESSENGER_TG);
    },
    isShowVB (): boolean {
      return this.isShowMessenger(CONF_MESSENGER_VB);
    },
    isShowTT (): boolean {
      return this.isShowMessenger(CONF_MESSENGER_TT);
    },
    isShowDC (): boolean {
      return this.isShowMessenger(CONF_MESSENGER_DISCORD);
    }
  },
  methods: {
    isShowMessenger (messengerName: string) {
      const messenger = config(messengerName);

      if (!messenger) {
        return false
      }

      return messenger === 'true' || messenger === 'TRUE' || messenger === true
    },
    hasMsgr (msgr: string): boolean {
      if (this.msgr) {
        if (this.msgr.indexOf(msgr) >= 0) {
          return true
        }
      }
      return false
    },
    async onMsgrClick (msgr: string) {
      try {
        if (this.msgr) {
          if (!this.hasMsgr(msgr)) {
            if (!this.codes[msgr]) {
              await this.getCode(msgr)
            }
            this.openModal(msgr);
          } else {
            this.authDrop(msgr)
          }
        }
      } catch (error) {
        console.error('LOG: onMsgrClick -> error', error)
      }
    },
    async openModal (msgr: string) {
      this.popupVisible[msgr] = true;
    },
    async authDrop (msgr: string) {
      try {
        // @ts-ignore
        await this.$confirm(`${this.$t('settings.sure_disable_notifications_in')} ${MSGR_DICT[msgr]}`, this.$t('labels.attention'), {
          confirmButtonText: this.$t('labels.disable'),
          cancelButtonText: this.$t('labels.cancel'),
          type: 'warning'
        })
        // @ts-ignore
        this.$message({
          type: 'success',
          // @ts-ignore
          message: this.$t('settings.notifications_disabled')
        });
        await this.$store.dispatch('user/unbind', {msgr})
        await this.reloadUser();
      } catch (e) {
        console.log(e)
      }
    },
    async getCode (msgr: string): Promise<void> {
      try {
        if (msgr) {
          // workaround: Discord uses TG code as mock
          let resp = await this.$store.dispatch('user/getCode', {msgr})
          this.codes = {}
          this.codes[resp.msgr] = resp
          await this.reloadUser();
        }
      } catch (error) {
        console.error('getCode', error)
        // @ts-ignore
        this.$message.error(this.$t('settings.can_not_send_code'))
      }
    },
    async reloadUser (): Promise<void> {
      await this.$store.dispatch('user/loadUser', true)
    },
    // @ts-ignore
    async copyText (text: string, target = this.$t('settings.code_copyied')) {
      try {
        this.$copyText(text);
        // @ts-ignore
        this.$message.success(`${target} ${this.$t('settings.to_clipboard')}`)
      } catch (error) {
        // @ts-ignore
        this.$message.warning(this.$t('messengers.can_not_copy_code'))
      }
    },
    onTimerExpired (): void {
      this.reloadUser()
    },
    showConfirm (msgr: string) {
      console.log('LOG: showConfirm -> msgr', msgr)
      this.confirmVisible[msgr] = true;
    },
    closeAllPopups () {
      for (let key in this.popupVisible) {
        this.popupVisible[key] = false;
      }
    },
    closeConfirm (msgr: string) {
      this.confirmVisible[msgr] = false;
    },
    userDataWatcher (): void {
      // @ts-ignore
      this.interval = setInterval(() => {
        this.reloadUser();
      }, 4000)
    }
  },
  mounted () {
    this.userDataWatcher()
  },
  watch: {
    msgr (newVal, oldVal) {
      if (!oldVal) return;
      let diffKeys: string[] = _.difference(newVal, oldVal);
      if (diffKeys.length) {
        this.closeAllPopups();
        for (const msgr of diffKeys) {
          this.showConfirm(msgr);
        }
      }
    }
  },
  beforeDestroy () {
    // @ts-ignore
    clearInterval(this.interval)
  }
})
